import * as React from "react";
import BaseUI, { IBaseUI } from "src/engine/ui/BaseUI";
import { Modal, Button } from "antd";
import UIManifest from "src/engine/ui/UIManifest";
import "./PCModal.scss";
import IUIItem from "src/engine/interface/IUIItem";
import AutoContext from "src/engine/decorator/AutoContext";
import PanelContext from "src/engine/context/PanelContext";
import Style from "src/lib/utils/Style";
import ButtonCheck from "src/components/Button/ButtonCheck";
// import { Source } from "src/engine/interface/Source";
// import ButtonLink from "src/mobile/ui/common/Button";

interface IPCModal extends IBaseUI {
    //弹框标题字符串
    title?: string;
    onClick?: any;
    dataKey?: [];
    styleClass?: string; //弹层位置
    isfullHeight?: string; //是否高度100%
    /**
     *
     * 是否允许点击蒙版关闭
     * @type {boolean}
     * @memberof IButtonDialog
     */
    maskClosable?: boolean;
    /** 是否显示右上角的关闭按钮 */
    closable?: boolean;
    /**
     * 点击modal之前预处理
     *
     * @memberof IButtonDialog
     */
    openBefore?: (data: any, type?: string) => boolean;
    // 关闭modal后的处理
    afterClose?: any;
    /**
     * dialog宽度
     */
    width?: any;
    bodyStyle?: any;
    className?: string;
    refreshOption?: string; //刷新数据源
    /**
     *
     * 弹窗数据
     * @type {*}
     * @memberof IPCModal
     */
    data?: any;
    visible?: boolean;
    hidePop?: any;
    renderChildren?: boolean;
    showChildren?: IUIItem[];
    container?: "undefined" | "false" | "null" | "other";
    containerId?: string;
}
@UIManifest.declareGG(["ggValue", "dataValue", "uiCheck"], "PCModal", "PCModal组件", UIManifest.Type.PC)
class PCModal extends BaseUI<IPCModal> {
    closeCheck: ButtonCheck = new ButtonCheck();

    state = {
        visible: !!this.props.visible,
        loading: false,
    };

    handleVisibleChange = (visible: boolean, e?: any) => {
        //阻止冒泡
        e?.stopPropagation?.();
        if (this.state.visible === visible) return;
        const { refreshOption } = this.props;
        this.setState({ visible });
        if (refreshOption && !visible) {
            //关闭弹窗刷新数据源
            this.sourceContext.execSource(refreshOption);
        }
        const { onClick } = this.props; //解决popup里面套modal，无法关闭popup的问题
        if (onClick && !visible) {
            onClick(false);
        }
    };
    componentDidMount = () => {
        if (this.props.hidePop) {
            this.props.hidePop(this.onBack);
        }
    };
    renderContent = () => {
        if (!this.state.visible) {
            return null;
        }
        const { data } = this.props;
        const props: any = {
            handleRet: this.onBack,
            noPanelForm: true,
            onClick: this.onBack,
            onClose: this.handleVisibleChange.bind(this, false),
        };
        if (data) props.data = data;
        return this.renderChildren(this.props.children, props);
    };

    onBack = (e: any) => {
        e?.stopPropagation?.();
        // 限制连续点击右上角关闭按钮造成页面回退的情况 500ms的时间后续如果有需要可替换成配置项
        const check = this.closeCheck.check(500);
        if (!check) return;
        if (this.pageContext.contextInit) {
            this.goBack();
        } else {
            this.handleVisibleChange(false);
        }
    };

    afterClose = () => {
        const { afterClose } = this.props;
        if (afterClose && typeof afterClose === "function") {
            afterClose();
        }
    };

    openBefore = (e: any) => {
        //阻止冒泡
        e?.stopPropagation?.();
        this.handleVisibleChange(true);
        const { data = {} } = this.props;
        this.props.openBefore?.(data);
        if (this.pageContext.contextInit) {
            this.pageContext.registerBackListener(() => {
                this.handleVisibleChange(false);
            });
        }
    };
    renderButton() {
        const { visible, uiItem, showChildren = [], data = {} } = this.props;
        const item: any = {};
        if (!visible) {
            if (showChildren.length > 0) {
                return this.renderChildren(showChildren, { onClick: this.openBefore, data });
            }
            return (
                <Button {...item} type="primary" loading={this.state.loading} onClick={this.openBefore}>
                    {uiItem.info.cname}
                </Button>
            );
        }
        return null;
    }

    getContainerProps() {
        const { container, containerId } = this.props;
        let getContainer: false | HTMLElement | null = null;
        if (container === "undefined" || container === void 0) {
            getContainer = this.mPanelContext.renderType !== "app" ? document.getElementById("editor-core-view") || false : null;
        } else if (container === "null") {
            getContainer = null;
        } else if (container === "false") {
            getContainer = false;
        } else if (container === "other" && containerId) {
            getContainer = document.getElementById(containerId) || null;
        }
        return getContainer;
    }

    @AutoContext(PanelContext, "mPanelContext")
    renderAct() {
        const { renderChildren, children, uiItem, title, width, className, maskClosable, styleClass, isfullHeight, closable = true } = this.props;
        const nameClass = `tsx-modal ` + styleClass + ` ` + (isfullHeight === "true" ? "fullHeight" : "");
        const { bodyStyle, maskStyle } = Style.getMainStyle(["bodyStyle"], this.props);
        // const getContainer = this.getContainerProps();

        return (
            <div className={`react-button-dialog ${className}`} style={this.getStyle()}>
                {this.renderButton()}
                <Modal
                    className={nameClass}
                    title={title || uiItem.info.cname}
                    maskClosable={maskClosable}
                    width={width || 700}
                    // height={height || "auto"}
                    footer={false}
                    afterClose={this.afterClose}
                    centered={true}
                    getContainer={this.getContainerProps()}
                    closable={closable}
                    destroyOnClose={true}
                    visible={this.state.visible}
                    maskStyle={maskStyle}
                    // wrapStyle = {{...style.wrapStyle,...wrapStyle}}
                    bodyStyle={Style(bodyStyle)}
                    onCancel={this.onBack}
                >
                    {renderChildren ? children : "" || this.renderContent()}
                </Modal>
            </div>
        );
    }
}

export default PCModal;
